/**
 * header-rebuild.js — Mercy Oil header behaviour add-ons (visual restyle support).
 *  1. <mo-announce> fade rotation between two messages (6s / 400ms via CSS).
 *  2. Cart badge: hide at zero + 1->1.15->1 pulse on cart change.
 * Both respect prefers-reduced-motion. No changes to existing header behaviour.
 */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Announcement fade rotation --- */
  if (!customElements.get('mo-announce')) {
    customElements.define('mo-announce', class extends HTMLElement {
      connectedCallback() {
        var msgs = Array.prototype.slice.call(this.querySelectorAll('.mo-announce__msg'));
        if (msgs.length < 2) return;
        if (reduce || this.dataset.rotate === 'false') return;
        var interval = parseInt(this.dataset.interval, 10) || 6000;
        var i = 0;
        var self = this;
        this._timer = setInterval(function () {
          msgs[i].classList.remove('is-active');
          i = (i + 1) % msgs.length;
          msgs[i].classList.add('is-active');
        }, interval);
        void self;
      }
      disconnectedCallback() { if (this._timer) clearInterval(this._timer); }
    });
  }

  /* --- Cart badge --- */
  function cartEl() { return document.getElementById('cart-drawer-toggle'); }

  function syncCart() {
    var cart = cartEl();
    if (!cart) return null;
    var badge = cart.querySelector('.thb-item-count');
    if (!badge) return null;
    var raw = (badge.textContent || '').trim();
    var hasContent = badge.children.length > 0 || (raw !== '' && raw !== '0');
    cart.classList.toggle('cart-empty', !hasContent);
    return badge;
  }

  function pulse() {
    var badge = syncCart();
    if (!badge || reduce) return;
    badge.classList.remove('mo-pop');
    void badge.offsetWidth; // restart animation
    badge.classList.add('mo-pop');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCart);
  } else {
    syncCart();
  }
  // Theme fires these around add-to-cart / cart updates.
  document.addEventListener('cart:refreshed', pulse);
  document.addEventListener('cart:refresh', function () { setTimeout(pulse, 350); });
})();
